<template>
    <div class="PinView" :class="classes">
        <div class="PinViewButton" @click="toggle()">
            <svg-view name="pin"></svg-view>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PinView',
    mixins: [mixins.ValidationComponentMixin],
    props: {
        value: { type: [Object, Boolean], default: false },
        modes: { type: Array, default: () => [] }
    },
    computed: {
        classes() {
            let classes = this.modes.map((m) => `PinView--${m}`);
            if (this.innerValue) {
                classes.push('PinView--pinned');
            }

            return classes;
        }
    },
    methods: {
        toggle() {
            this.innerValue = !this.innerValue;
        }
    }
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .PinView;

@{r} {
    position: absolute;
    background: @color-gray;
    top: 10px;
    right: 10px;
    z-index: 1;
    border-radius: 50%;
    cursor: pointer;
    border: 2px solid #dddfdf;

    svg {
        width: 22px;
        height: 13px;
        display: inline-block;
        fill: @color-black;
    }

    &:hover {

        .PinViewButton {
            opacity: .7;
        }
    }

    &--pinned {
        background: @color-black;

        .PinViewButton svg {
            fill: @color-gray;
        }
    }

    &Button {
        display: block;
        position: relative;
        padding: 10px 8px 9px 8px;

        transition: opacity 0.2s;

        &:after {
            display: none;
            content: "";
            position: absolute;
            top: 9px;
            left: 10px;
            transform: rotate(45deg);
            transform-origin: 0 0;
            width: 28px;
            height: 0;
            border-top: 2px solid @color-black;
        }
    }
}
</style>
